/**
 * 广告道具逻辑 H5专供
 */
let AdPropLogic = xClass("AdPropLogic")
const TIP_WAITING = 2000;   // 用户不操作出提示气泡的时间

// 依赖资源
const RES = [
    "packed/startPanelAdItem.pack", 
    "font/zzgftongxin_40_greenstroke.fnt"
]; 
  
const ResStatus = {
    Unload: 0,
    Loading: 1,
    Loaded: 2
}
AdPropLogic.prototype.ctor = function () {
    let self = this;

    self.isRunning = false;
    self.config = null;
    self.isLoadConfig = false;
    self.adRefreshCount = null;
    self.noMoveHappened = false;

    self.refreshBeforeRevive = 0;
    self.refreshAfterRevive = 0;

    self.resStatus = ResStatus.Unload;

    self.propInStage = false;

    self.tipTimer = null;
    self.tip = null;
    self.tipFlag = false;

    self.stableChecked = false;

    self.hasRfreshProp = false;
    self.hasRfreshPropHasShowTip = false;

}

AdPropLogic.prototype.start = function (adRefreshCount) {
    let self = this;

    if (!SnsProxy.getInstance().allowAd()) {
        console.warn("[AdRefresh]platform doesnot allow ad.");
        return;
    }

    if (self.isRunning) {
        console.error("[AdRefresh]fail to start, cmpt is running.");
        return;
    }

    if (typeof adRefreshCount !== "number" || isNaN(adRefreshCount)) {
        console.error("[AdRefresh]adRefreshCount value is invaild.", adRefreshCount);
        return;
    }

    self.isRunning = true;
    self.adRefreshCount = adRefreshCount;

    GameplayEventDispatcher.getInstance().on(GameplayEvent.UseMove, function (evt) {
        if (evt.leftMoves === 0) {
            self.noMoveHappened = true;
            self.tipFlag = false;
        }

        self.checkOnStepChange(evt.leftMoves);

    }, "AdPropLogic");

    checkConfig(self);
    checkRes(self);
}

AdPropLogic.prototype.stop = function () {
    let self = this;

    if (self.isRunning) {
        GameplayEventDispatcher.getInstance().removeEventListenersByTag("AdPropLogic");

        rmTip(self);
        rmTipTimer(self);
        rmTipScheduler(self);
        self.tipFlag = false;

        self.isLoadConfig = false;
        self.isRunning = false;
        self.adRefreshCount = null;
        self.noMoveHappened = false;
        self.refreshBeforeRevive = 0;
        self.refreshAfterRevive = 0;
        self.propInStage = false;

        self.stableChecked = false;

        self.lastLeftMoves = -1;

        if (self.resStatus === ResStatus.Loaded) {
            self.resStatus = ResStatus.Unload;
            unloadResList(RES);
        }

        self.hasRfreshProp = false;
        self.hasRfreshPropHasShowTip = false;
    }
}

/**
 * start的时候bar可能还不存在，所以需要在稳定态下判断一下是否背包内有刷新道具
 */
AdPropLogic.prototype.onBoardStable = function() {
    let self = this;
    if (self.isRunning && !self.stableChecked) {
        let bar = getGameBar();
        if (bar) {
            self.stableChecked = true;
            let [_, __, ___, totalNum, ____, ad] = bar.getPropNumber(UserAdPropToPropRef[GamePropIds.kRefresh_ad]);
            if (totalNum > ad) {
                // console.warn("[AdRefresh]will stop while refresh-prop in bag.");
                // self.stop();
                // return;
                console.log("[AdRefresh]user has refresh-prop in bag.");
                self.hasRfreshProp = true;
            };
        }
    }
}

AdPropLogic.prototype.enterWaitingOperation = function (enter) {
    let self = this;
    if (!self.isRunning)
        return;
        
    // console.log("[AdRefresh] hasRfreshProp", self.hasRfreshProp)
    // console.log("[AdRefresh] hasRfreshPropHasShowTip", self.hasRfreshPropHasShowTip)

    checkConfig(self);
    if (!self.config)
        return;

    checkRes(self);
    if (self.resStatus !== ResStatus.Loaded)
        return;

    rmTipScheduler(self);
    rmTipTimer(self);
    rmTip(self);

    var [_, __, ___, totalNum] = getGameBar().getPropNumber(GamePropIds.kRefresh)
    if (!getGameBar().isVisible()){
        // 前5关没有道具栏的不显示
        return
    }
    if (self.hasRfreshProp && (totalNum == 0 || !UserLevel.getInstance().canUseProp(GamePropIds.kRefresh, 1)[0])){
        // 开始关卡时自有刷新但是用完了的，不再显示气泡
        return
    }
    if (self.hasRfreshProp && self.hasRfreshPropHasShowTip){
        // 自由刷新道具的只会显示一次
        return;
    }
    if (!self.propInStage) {
        return;
    }

    if (enter && !self.tipFlag) {
        self.tipTimer = setTimeout(function () {
            if (self.isRunning && self.propInStage) {
                addTip(self);
                if (self.hasRfreshProp){
                    self.hasRfreshPropHasShowTip = true;
                }
            }
        }, TIP_WAITING);
    }
}

AdPropLogic.prototype.getPropsInBar = function () {
    return [GamePropIds.kRefresh_ad];
}

AdPropLogic.prototype.isShowInStage = function (propId) {
    let self = this;
    if (!self.isRunning)
        return false;

    if (propId === GamePropIds.kRefresh_ad)
        return self.propInStage;
    else
        return false;
}
AdPropLogic.prototype.checkOnRevive = function () {
    let self = this;

    if (!self.isRunning)
        return false;

    checkConfig(self);
    if (!self.config)
        return false;

    checkRes(self);
    if (self.resStatus !== ResStatus.Loaded)
        return false;

    let mainLogic = cc.director.getRunningScene().logic;
    if (mainLogic.replaying || mainLogic.replayingStrategy)
        return false;

    if (self.propInStage)
        return false;

    if (self.adRefreshCount >= self.config.todayLimit){
        console.log(`[AdTag] 关内刷新道具广告限制 limit=${self.config.todayLimit} 当前次数${self.adRefreshCount}`)
        return false;
    }

    if (self.refreshAfterRevive >= self.config.reviveLimit)
        return false;

    self.propInStage = true;
    cc.director.getRunningScene().ui.gamePropBar.update();
    return true;
}

AdPropLogic.prototype.playAd = function (propId, callback) {
    let self = this;

    // DCAssist.userTrack("stage", "ad_refresh_click", { ad_type: "click", type: self.noMoveHappened ? "addstep" : "stage" });
    DCAssist.dc4AdClick("stage", "ad_refresh_click", { ad_type: "click", type: self.noMoveHappened ? "addstep" : "stage" })

    SnsProxy.getInstance().showAd("AdRefreshInBattle")
        .then(isEnd => {
            if (isEnd) {
                let ad_time = SnsProxy.getInstance().getPlayADTime();
                // DCAssist.userTrack("stage", "ad_refresh_finish", { 
                //     ad_type: "finish",
                //     type: self.noMoveHappened ? "addstep" : "stage",
                //     "ad_time": ad_time,
                //  });
                 DCAssist.dc4AdFinish("stage", "ad_refresh_finish", { 
                    ad_type: "finish",
                    type: self.noMoveHappened ? "addstep" : "stage",
                    "ad_time": ad_time,
                 });
                DCAssist.dc4GetThings(GamePropIds.kRefresh_ad, 1, "ad_stage_refresh", {
                    category: "ad",
                    item_worth:"ad",
                    sub_category: "stage_refresh"
                });
                callback && callback(null)
            } else {
                // DCAssist.userTrack("stage", "ad_refresh_dropout", { ad_type: "dropout" });
                DCAssist.dc4AdDropOut("stage", "ad_refresh_dropout");
                callback && callback("dropout_ad");
            }
        })
        .catch(err => {
            // DCAssist.userTrack("stage", "ad_refresh_noAds", { ad_type: "noAds" });
            DCAssist.dc4AdNoMore("stage", "ad_refresh_noAds")
            callback && callback("noAds");
        })
}

AdPropLogic.prototype.useProp = function (propId, inReplay = false) {
    let self = this;
    if (!self.isRunning)
        return;

    if (propId !== GamePropIds.kRefresh_ad)
        return;
        
    if (self.hasRfreshProp){
        return;
    }

    self.propInStage = false;
    if (self.noMoveHappened) {
        self.refreshAfterRevive = self.refreshAfterRevive + 1;
    } else {
        self.refreshBeforeRevive = self.refreshBeforeRevive + 1;
    }

    if (!inReplay)
        self.adRefreshCount = self.adRefreshCount + 1
}


AdPropLogic.prototype.checkOnStepChange = function (step) {
    let self = this;
    if (!self.isRunning)
        return;

    checkConfig(self);
    if (!self.config)
        return false;

    checkRes(self);
    if (self.resStatus !== ResStatus.Loaded)
        return false;

    let mainLogic = cc.director.getRunningScene().logic;
    if (!mainLogic)
        return;

    if (mainLogic.replaying || mainLogic.replayingStrategy)
        return false;

    if (self.propInStage)
        return false;

    if (self.hasRfreshProp){
        if (UserLevel.getInstance().canUseProp(GamePropIds.kRefresh, 1)[0]){
            // 自由刷新道具的tip
            if (!self.noMoveHappened && self.config.refreshMoveLimit >= step) {
                self.propInStage = true;
                // gamePropBar在这之后会自行更新一下，不需要特地调用update
                return true;
            }
        }else{
            return false;
        }
    }else{
        if (self.adRefreshCount >= self.config.todayLimit){
            console.log(`[AdTag] 关内刷新道具广告限制 limit=${self.config.todayLimit} 当前次数${self.adRefreshCount}`)
            return false;
        }

        if (self.refreshBeforeRevive >= 1)
            return false;

        if (!self.noMoveHappened && self.config.moveLimit === step) {
            self.propInStage = true;
            // gamePropBar在这之后会自行更新一下，不需要特地调用update
            return true;
        }
    }

    return false;
}

/**
 * 检查配置是否已经下完，如果没有需要重新下载
 */
function checkConfig(self) {
    if (!self.config && !self.isLoadConfig) {
        self.isLoadConfig = true;

        CfgManager.load("ad_props")
            .then(() => {
                let config = CfgManager.get("ad_props");
                CfgManager.release("ad_props");
                self.config = {
                    // todayLimit:10
                    todayLimit: parseInt(config["ad_ingameprop_refresh_num"]),  // 每个自然日可以获取的刷新次数上限
                    moveLimit: parseInt(config["ad_ingameprop_refresh_move1"]), // 获得刷新机会的剩余步数
                    reviveLimit: parseInt(config["ad_ingameprop_refresh_num2"]), // 复活后可以获取刷新机会的单局次数上限
                    refreshMoveLimit: parseInt(config["ingameprop_refresh_move"]), // 剩余步数出自有刷新道具使用提示
                    refreshShowLimit: 1, // 自有刷新道具使用提示次数上限
                }
                let [isOpen,limit] = AdTagManager.getInstance().getAdStrategyByAdType(AdTagManager.AdType.ad_ingameprop)
                if (isOpen){
                    if(self.config.todayLimit > limit){
                        self.config.todayLimit = limit
                    }
                }else{
                    console.log(`[AdTag] 关内刷新道具广告限制 isOpen=${isOpen}`)
                    self.config.todayLimit = 0
                }
        
                self.isLoadConfig = false;
            })
            .catch(err => {
                console.error("[AdRefresh] load config failed.", err);
                self.isLoadConfig = false;
            })
    }
}

// 检查资源是否下载完成
function checkRes(self) {
    if (self.resStatus === ResStatus.Unload) {
        self.resStatus = ResStatus.Loading;

        function onFail() {
            self.resStatus = ResStatus.Unload;
        }

        // 资源加载完毕
        function onLoad() {
            self.resStatus = ResStatus.Loaded;

            if (!self.isRunning) {
                self.resStatus = ResStatus.Unload;
                unloadRes(RES);
            }
        }
        preloadWithLoading(RES, onLoad, onFail, onFail, false);
    }
}

function getGameBar() {
    let scene = cc.director.getRunningScene();
    if (!scene)
        return null;

    if (!scene.ui)
        return null;

    return scene.ui.gamePropBar;
}
function getBubbleWorldPos() {
    let gameBar = getGameBar();
    if (!gameBar)
        return null;

    let pos = gameBar.getBubblePositionByPropId(GamePropIds.kRefresh_ad);
    if (!pos)
        return;

    let [worldPos, _] = pos;
    return worldPos;
}

function addTip(self) {
    self.tipFlag = true;

    let worldPos = getBubbleWorldPos();
    if (!worldPos)
        return;

    function remove() {
        rmTip(self);
        rmTipTimer(self);
        rmTipScheduler(self);
    }

    let tipOffsetX = 100, tipOffsetY = 70, minTipX = 126
    let StartPanelAdTip = require("clover/panel/startPanelAd/StartPanelAdTip");
    let tip = StartPanelAdTip.create(getText("ad_ingameprop_refresh_text1"));
    tip.getChildByName("main").getChildByName("whitebubblespeak").setContentSize(cc.size(300, 118));
    tip.getChildByName("main").getChildByName("boxTail").x = -60;
    tip.getChildByName("main").getChildByName("label").fontSize = 27;
    tip.getChildByName("main").getChildByName("label").width = 350;
    tip.setPosition(Math.max(minTipX, worldPos.x + tipOffsetX), worldPos.y + tipOffsetY);
    cc.director.getRunningScene().addChild(tip, 999);
    tip.onRemove(remove);
    self.tipView = tip;

    let tipMask = Mask.make(0, 0, 0, 0, true, remove);
    tipMask.setTouchEnabled(true);
    cc.director.getRunningScene().addChild(tipMask, 999); v,
        self.tipMask = tipMask;

    function upPos() {
        if (self.tipView) {
            let wp = getBubbleWorldPos();
            if (wp) {
                self.tipView.setPosition(Math.max(minTipX, wp.x + tipOffsetX), wp.y + tipOffsetY);
            }
        }
    }

    self.tipScheduler = cc.director.getScheduler().scheduleScriptFunc(upPos, 0, false);
}

function rmTip(self) {
    if (self.tipView) {
        self.tipView.close();
        self.tipView = null;
    }
    if (self.tipMask) {
        self.tipMask.removeFromParent(true);
        self.tipMask = null;
    }
}

function rmTipTimer(self) {
    if (self.tipTimer) {
        clearTimeout(self.tipTimer);
        self.tipTimer = null;
    }
}

function rmTipScheduler(self) {
    if (self.tipScheduler) {
        cc.director.getScheduler().unscheduleScriptEntry(self.tipScheduler);
        self.tipScheduler = null;
    }
}

let _logic = AdPropLogic.create();
module.exports = _logic;